package com.starparty.app.astro0

import com.starparty.app.astro0.celestialobjects.CelestialPoint
import com.starparty.app.astro0.celestialobjects.ConstBoundaryData
import com.starparty.app.astro0.celestialobjects.ConstBoundaryData2
import com.starparty.app.astro0.celestialobjects.ConstBoundaryData3
import com.starparty.app.astro0.celestialobjects.Constellation
import com.starparty.app.astro0.celestialobjects.ConstellationBoundary
import com.starparty.app.astro0.celestialobjects.Star
import com.starparty.app.astro0.readers.ConstellationReader
import com.starparty.app.astro0.readers.StarReader
import com.starparty.app.vector_maths.Matrix4d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class StarField(time: SP_Time /*, InputStream starsIS, InputStream constellationsIS*/) {
    var stars: Array<Star> = arrayOf()
        protected set
    var constellations: Array<Constellation> = arrayOf() // (Constellation.Companion.NUM_OF_CONS)
        protected set

    var constellationBoundaries1: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries2: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries3: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries4: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries5: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries6: Array<Array<CelestialPoint>> = arrayOf()
    var constellationBoundaries7: Array<Array<CelestialPoint>> = arrayOf()

    var showConstellationType = Sky.CONSTELLATION_LINES_ONLY
    var isShowingStars = true

    /** Sets the locations of all the bodies  */
    fun project(transform: Matrix4d) {

        for (star in stars.indices) {
            stars[star].setSkyLocation(transform)
  //val sp = stars[star].skyLocation
  //val spx = sp.x
  //val spy = sp.y
  //console.log("proj:$spx:$spy ")
        }

        // Project constellation name points
        for (con in constellations.indices) {
            constellations[con].titlePoint.setSkyLocation(transform)
        }

        for (line in constellationBoundaries1){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries2){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries3){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries4){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries5){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries6){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
        for (line in constellationBoundaries7){
            for (point in line) {
                point.setSkyLocation(transform)
            }
        }
    }

    protected fun makeStarField(time: SP_Time /*, InputStream starsIS, InputStream constellationsIS*/) {
        stars = StarReader.makeStars(time /*, starsIS*/)
        constellations = ConstellationReader.makeConstellations()
        for (s in stars.indices) {
            addStar(stars[s])
        }
        constellationBoundaries1 = ConstellationReader.makeConstellationBoundaries(ConstellationReader.boundaries1)
        constellationBoundaries2 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData.boundaries2)
        constellationBoundaries3 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData.boundaries3)
        constellationBoundaries4 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData2.boundaries4)
        constellationBoundaries5 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData2.boundaries5)
        constellationBoundaries6 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData3.boundaries6)
        constellationBoundaries7 = ConstellationReader.makeConstellationBoundaries(ConstBoundaryData3.boundaries7)
    }

    fun addStar(s: Star) {
        val con = s.constellation
        //
        if (con != Constellation.UNKNOWN_CONST) {
            constellations[con].addStar(s)
        }
    }

    init {
        makeStarField(time /*, starsIS, constellationsIS*/)
    }
}